module.exports = __webpack_public_path__ + "img/SCENE_THUMBNAIL.e0e3c87c.svg";